'use client';

import { useState } from 'react';
import Icon from '@/components/ui/AppIcon';

interface ServiceCardProps {
  icon: 'BuildingOfficeIcon' | 'ScaleIcon' | 'LightBulbIcon' | 'CurrencyDollarIcon' | 'GlobeAltIcon' | 'ShieldCheckIcon' | 'DocumentTextIcon';
  title: string;
  description: string;
  details: string[];
}

export default function ServiceCard({ icon, title, description, details }: ServiceCardProps) {
  const [expanded, setExpanded] = useState(false);

  return (
    <div className="bg-card border-2 border-primary/20 rounded-2xl p-8 hover:shadow-xl hover:border-primary/40 transition-all">
      <div className="flex items-start justify-between mb-6">
        <div className="w-14 h-14 rounded-full bg-primary/10 flex items-center justify-center shadow-md">
          <Icon name={icon} size={28} className="text-primary" />
        </div>
        <button
          onClick={() => setExpanded(!expanded)}
          className="w-10 h-10 rounded-full border-2 border-primary/30 flex items-center justify-center hover:bg-primary/5 hover:border-primary/50 transition-all"
          aria-label={expanded ? 'Collapse' : 'Expand'}
        >
          <Icon
            name={expanded ? 'ChevronUpIcon' : 'ChevronDownIcon'}
            size={20}
            className="text-foreground"
          />
        </button>
      </div>

      <h3 className="text-2xl font-serif text-foreground mb-3">{title}</h3>
      <p className="text-muted-foreground leading-relaxed mb-6">{description}</p>

      {expanded && (
        <div className="border-t-2 border-primary/20 pt-6 space-y-3 animate-fade-in">
          {details.map((detail, index) => (
            <div key={`detail_${index}`} className="flex items-start gap-3">
              <Icon name="CheckCircleIcon" size={20} className="text-secondary mt-0.5 flex-shrink-0" />
              <span className="text-sm text-muted-foreground">{detail}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}